// External Dependencies
import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import overviewContainerView  from '../../../../templates/MIPS/Quality/overviewContainerView';

// Internal Dependencies - models/collections

export default Marionette.ItemView.extend({

    initialize: function() {
        this.channel = Backbone.Radio.channel( 'AppChannel' );
        this.app = this.channel.request( 'app' );
    },

    getTemplate: function() {
        return overviewContainerView( this.model );
    },

    onShow: function() {
        this.channel.trigger( 'render:summaryChart' );
    },

});
